import { baseApi } from 'services/api';
import { API_VERSION } from 'constants/common';
import {
  ApiResponse,
  GetInvoiceSettingsPayload,
  InvoiceSettingsResponse,
  UpdateDueDatePayload,
  UpdatePartialPaymentPayload,
  UpdateRemindersPayload,
  UpdateRemindersTogglePayload
} from './invoiceSettings.model';

const InvoiceSettingsApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // New Invoice Settings APIs
    getInvoiceSettings: builder.query<InvoiceSettingsResponse, GetInvoiceSettingsPayload>({
      query: ({ teamId }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/invoices/settings`,
        method: 'GET'
      }),
      extraOptions: {
        failure: 'Failed to fetch invoice settings',
        showToast: false
      }
    }),

    updateInvoiceSettingsDueDate: builder.mutation<ApiResponse, UpdateDueDatePayload>({
      query: ({ teamId, duePeriod, dueDuration }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/invoices/settings/due-date`,
        method: 'PATCH',
        body: { duePeriod, dueDuration }
      }),
      extraOptions: {
        failure: 'Failed to update due date',
        showToast: true
      }
    }),

    updateInvoiceSettingsPartialPayment: builder.mutation<ApiResponse, UpdatePartialPaymentPayload>({
      query: ({ teamId, partialPaymentStatus }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/invoices/settings/partial-payment`,
        method: 'PATCH',
        body: { partialPaymentStatus }
      }),
      extraOptions: {
        failure: 'Failed to update partial payment status',
        showToast: true
      }
    }),

    updateInvoiceSettingsReminders: builder.mutation<ApiResponse, UpdateRemindersPayload>({
      query: ({ teamId, reminders }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/invoices/settings/reminders`,
        method: 'PUT',
        body: { reminders }
      }),
      extraOptions: {
        success: 'Payment reminders updated successfully!',
        failure: 'Failed to update payment reminders',
        showToast: true
      }
    }),

    updateInvoiceSettingsRemindersToggle: builder.mutation<ApiResponse, UpdateRemindersTogglePayload>({
      query: ({ teamId, remindersEnabled }) => ({
        url: `${API_VERSION.V1}/teams/${teamId}/invoices/settings/reminders/toggle`,
        method: 'PATCH',
        body: { remindersEnabled }
      }),
      extraOptions: {
        failure: 'Failed to update payment reminders',
        showToast: true
      }
    })
  })
});

export const {
  useLazyGetInvoiceSettingsQuery,
  useUpdateInvoiceSettingsDueDateMutation,
  useUpdateInvoiceSettingsPartialPaymentMutation,
  useUpdateInvoiceSettingsRemindersMutation,
  useUpdateInvoiceSettingsRemindersToggleMutation
} = InvoiceSettingsApi;
